import { keepPhoneChars } from '../constants/validityPatterns';

/**
 * The value as it will be SENT: digits only, except for a single leading +.
 *
 * It previously stripped every non-digit, which was right while the only accepted form was UK. With
 * E.164 that silently removed the + - so `+33612345678` left here as `33612345678`, which the API
 * then rejects for reasons an admin cannot see. Stripping the mask's spaces is still the job; losing
 * the country marker never was.
 *
 * A + anywhere but the front is dropped rather than kept, because there is no number it could mean.
 *
 * @param {string} value
 * @returns {string}
 */
export default function transformPhone(value) {
    if (!value) {
        return value;
    }

    const trimmed = String(value).trim();
    const isInternational = trimmed.startsWith('+');

    // A parenthesised trunk prefix - the "(0)" in "+44 (0)7700 900123" - is what you dial INSTEAD of
    // the country code, never as well as it. Removing only the brackets leaves "+4407700900123":
    // thirteen digits, which satisfies the pattern on BOTH sides and so is accepted everywhere, and
    // cannot be dialled. So it is dropped whole.
    //
    // Only when the number is international. "(0)7700900123" written nationally keeps its zero,
    // because there the 0 IS the number's own prefix rather than a stand-in for a country code.
    // Brackets that are not a trunk prefix - "+1 (415) 555-0132" - are ordinary formatting and only
    // their punctuation goes.
    const withoutTrunkPrefix = isInternational ? trimmed.replace(/\(\s*0\s*\)/, '') : trimmed;
    const digits = withoutTrunkPrefix.replace(keepPhoneChars, '').replace(/\+/g, '');

    return isInternational ? `+${digits}` : digits;
}
